import { useContext } from "react";
import type { StringText } from "../objects-global";
import IOAbstract, { EditContext, type IOProps } from "./io-abstract";

export default function IOText(props: IOProps<StringText>) {
  const editContext = useContext(EditContext);

  const adjust = (element: HTMLTextAreaElement) => {
    // const lines = element.value.split("\n").length;
    // element.setAttribute("rows", lines);

    element.style.height = "0";
    element.style.height = "calc(" + element.scrollHeight + "px + 2em)";
  };

  return (
    <IOAbstract<string>
      editContext={editContext}
      inputType="textarea"
      type="text"
      renderOutput={<div className="with-newlines">{props.value}</div>}
      renderInput={(uuid) => (
        <textarea
          id={uuid}
          className="form-control"
          name={props.name}
          rows={Math.max((props.value || "").split("\n").length, 2)}
          defaultValue={props.value ?? ""}
          required={props.required}
          onKeyUp={(event) => adjust(event.target as HTMLTextAreaElement)}
          onChange={(evt) => props.onChange?.(evt.target.value)}
        />
      )}
      {...props}
    />
  );
}
